import { FC, SVGAttributes } from "react";

const MinusSmall: FC<SVGAttributes<SVGSVGElement>> = ({
  width = "11px",
  height = "2px",
  ...rest
}) => (
  <svg
    viewBox="0 0 11 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    {...rest}
  >
    <path
      d="M0.75 0.75H10.0833"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { MinusSmall };
